import React from "react";
import ViewProduct from "../../components/viewProduct/view";

function View() {
  return (
    <div>
      <ViewProduct />
    </div>
  );
}

export default View;
